<template>
  <div class="container">
    <div id="header" class="flex flex-row-left  margin-top-20 ">
      <div class="flex-item-center">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="平台移货订单号">
            <el-input style="width:200px" v-model="formInline.saleNumber" placeholder="交易号或马帮销售单号" clearable />
          </el-form-item>
          <el-form-item label="物流单号">
            <el-input style="width:200px" v-model="formInline.receiveNumber" placeholder="物流单号" clearable />
          </el-form-item>
          <el-form-item label="产品相关">
            <el-input style="width:200px" v-model="formInline.receiveMaterSku" placeholder="产品SKU,名称,序列号" clearable />
          </el-form-item>
          <el-form-item label="入库仓库">
            <el-select
                v-model="formInline.warehouseId"
                filterable
                clearable
                @clear="formInline.warehouseId=''"
                :placeholder="请选择入库仓库"
                remote-show-suffix
                class="mobile-select"
            >
              <el-option
                  v-for="item in stockList"
                  :key="item.warehousefCode"
                  :label="item.warehouseName"
                  :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
                @clear="formInline.status=''"
                v-model="formInline.status"
                clearable
                collapse-tags
                collapse-tags-tooltip
                multiple
                placeholder="请选择状态"
                remote-show-suffix
                style="width: 150px"
            >
              <el-option
                  v-for="item in resiveList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="平台移货时间">
            <el-date-picker
                style="width: 150px"
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.startMonth"
                type="date"
                placeholder="移货时间"
                clearable
                @clear="formInline.startMonth=''"
            />
            -
            <el-date-picker
                style="width: 150px"
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.endMonth"
                type="date"
                placeholder="移货时间"
                clearable
                @clear="formInline.endMonth=''"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button type="success" @click="importData">导入</el-button>
            <el-button type="danger" @click="exportData">导出记录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="margin-20-0">
      <div>
        <el-table
            :max-height="dynamicHeight"
            :data="tableData"
            :preserve-expanded-content="true"
            :stripe="true" :border="true"
            :highlight-current-row="true"
            size="default"
            @sort-change="handleSortChange"
            @selection-change="handleSelectionChange"
        >
          <el-table-column
              label="来源平台"
              min-width="100"
              prop="typeName"
          ></el-table-column>
          <el-table-column
              label="平台退回订单号"
              min-width="100"
              prop="orderId"
          ></el-table-column>
          <el-table-column
              label="移货日期"
              min-width="100"
              prop="shipmentDate"
          ></el-table-column>
          <el-table-column
              label="产品SKU"
              min-width="100"
              prop="stockSku"
          ></el-table-column>
          <el-table-column
              label="产品名称"
              min-width="100"
              prop="productName"
          ></el-table-column>
          <el-table-column
              label="产品图片"
              width="175"
              prop="pictureUrl"
          >
            <template #default="scope">
              <MyImage :picture-url="scope.row.pictureUrl" :picture-url-list="[scope.row.pictureUrl] "></MyImage>
            </template>
          </el-table-column>
          <el-table-column
              label="移货数量"
              min-width="60"
              prop="quantity"
          >
          </el-table-column>
          <el-table-column
              label="物流状态"
              min-width="240"
              prop="trackStatus"
          >
            <template #default="scope">
              <div>
                  <span v-if="scope.row.trackStatus && typeof scope.row.trackStatus === 'object'">
                    <span v-for="(value, key) in scope.row.trackStatus" :key="key" >
                      <span v-if="key !== ''" >{{ key }}: {{ value==1?"已签收":"未签收" }}</span>
                      <span v-else >暂无物流信息</span>
                    </span>
                  </span>
                  <span v-else>
                    {{ scope.row.trackStatus }}
                  </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="签收地址"
              min-width="150"
              prop="trackStatus"
          >
            <template #default="scope">
              <div>
                地址邮编：<span >{{ scope.row.receiveAddress.recipientPostalCode }}</span>
              </div>
              <div>
                国家：<span >{{scope.row.receiveAddress.recipientCountry}}</span><br>
                省/州：<span >{{scope.row.receiveAddress.recipientProvince}}</span><br>
                市：<span >{{scope.row.receiveAddress.recipientCity}}</span><br>
                区域：<span >{{scope.row.receiveAddress.recipientDistrict}}</span><br>
                街道：<span >{{scope.row.receiveAddress.recipientDetailAddress}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="退货物流"
              min-width="80"
              prop="trackingNumber"
          ></el-table-column>
          <el-table-column
              label="签收状态"
              min-width="180"
              prop="receiveStatus"
          >
            <template #default="scope">
              <div>收货数量:{{scope.row.quantitys}} <el-button link type="primary" size="small" @click="signInfo(scope.row)">查看详情</el-button></div>
              <div>
                售后仓退货状态：
                <span v-if="scope.row.check==0" >待收货</span>
                <span v-else-if="scope.row.check==1" >部分收货</span>
                <span v-else >已收货</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="退回备注"
              min-width="80"
              prop="receiveRemarks"
          >
            <template #default="scope">
              <el-tooltip
                  class=""
                  effect="dark"
                  :content="scope.row.receiveRemarks"

              >
                <span class="ellipsis-3-lines" >{{scope.row.receiveRemarks}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              fixed="right"
              label="操作"
              min-width="80"
              prop="addServices"
          >
            <template #default="scope">
              <el-button :disabled ="scope.row.check" link type="primary" size="small" @click="check(scope.row)">退货入库</el-button>
              <el-button  link type="primary" size="small" @click="checkInfo(scope.row)">退货详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="currentPage"  :page-size="pageSize" :total="pageTotal" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
    </div>
    <arehouseAndQuality ref="arehouseAndQuality"  @closeEdit="close" ></arehouseAndQuality>
    <receiptInfo ref="receiptInfo"  @closeEdit="close" ></receiptInfo>
    <signInfo ref="signInfo"  ></signInfo>
    <importDialog ref="importDialog" @closeEdit="handleImportSuccess" />
  </div>
</template>
<script>
import {ElForm,ElFormItem,ElButton,ElInput,ElDatePicker,ElTable,ElTooltip,

  ElTableColumn,ElPagination,ElSelect,ElOption} from "element-plus";
import importDialog from '@/components/importDialog.vue'
import arehouseAndQuality from "@/components/arehouseAndQuality.vue";
import receiptInfo from "@/components/receiptInfo.vue";
import signInfo from "@/components/signInfo.vue";
import MyImage from "@/components/myImage.vue";
import {getRemovalShipmentData} from "@/utils/api";
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";
import {getLocalStockList} from "../../../public/js";
import {baseUrl} from "@/utils/requset";

export default {
  name: "signReceipt",
  mixins:[DynamicHeightMixin],
  components: {importDialog,receiptInfo,signInfo,arehouseAndQuality,ElForm,ElFormItem,ElButton,ElInput,ElDatePicker,ElTable,MyImage,ElSelect,ElOption,
    ElTableColumn,ElPagination,ElTooltip},
  data() {
    return {
      activeUserId: null,
      hoverUserId: null,
      formInline:{},
      resiveList:[
        {label:"物流未签收",value:1},
        {label:"物流已签收",value:2},
        {label:"仓库未签收",value:3},
        {label:"仓库已签收",value:4}
      ],
      countryList:[
        {label: "中国", value: "CN"},
        {label: "美国", value: "US"},
        {label: "英国", value: "GB"},
        {label: "日本", value: "JP"},
        {label: "韩国", value: "KR"},
        {label: "德国", value: "DE"},
        {label: "法国", value: "FR"},
        {label: "意大利", value: "IT"},
        {label: "西班牙", value: "ES"},
        {label: "葡萄牙", value: "PT"},
        {label: "荷兰", value: "NL"},
        {label: "比利时", value: "BE"},
        {label: "瑞士", value: "CH"},
        {label: "瑞典", value: "SE"},
        {label: "挪威", value: "NO"},
      ],
      tableData:[],
      stockList:[],
      currentPage:1,
      pageTotal:0,
      pageSize:20,
      importDialogVisible: false,
    }
  },
  beforeMount() {
    // 不用自动查询
    // this.getRemovalShipmentData();
    this.getLocalStockList()
  },
  methods:{
    exportData(){
      let pramas = Object.entries(this.formInline)
          .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
          .join('&');
      let url = baseUrl + 'after/removalShipmentDataExport?'+ pramas

      window.open(url)
    },
    // 修改原来的 importData 方法
    importData() {
      this.$refs.importDialog.open()
    },
    signInfo(data){
      this.$refs.signInfo.open(data,2)
    },
    // 导入成功后的回调
    handleImportSuccess() {
      // 可以在这里刷新表格数据或提示用户
      this.getRemovalShipmentData()
    },
    onSubmit(){
      this.PageNumber = 1
      this.getRemovalShipmentData()
    },
    getLocalStockList(){
      getLocalStockList().then(res => {
        this.stockList = res.filter(item=>{
          return item.warehouseName.includes("美国售后仓")
        })
      })
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getRemovalShipmentData();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getRemovalShipmentData();
    },
    getRemovalShipmentData(){
      getRemovalShipmentData({...this.formInline,PageSize:this.pageSize,PageNumber:this.currentPage}).then(res=>{
        this.tableData = res.Data
        this.pageTotal = res.Total
      }).catch(res=>{
        console.log(res)
      })
    },
    handleClick(data){
      this.$refs.receiptZendesk.open(data)
    },
    check(data){
      this.$refs.arehouseAndQuality.open(data,"平台退货")
    },
    checkInfo(data){
      this.$refs.receiptInfo.open(data,"平台退货")
    },
    close(){
      this.getRemovalShipmentData()
    }
  }
}
</script>
<style scoped>
.container{
  width: 92%;
  margin:0 auto;
}
::v-deep .container {
  .el-form-item{
    margin-bottom:0!important;
  }
}
::v-deep .el-table .el-button+.el-button{
  margin-left: 0 !important;
}
::v-deep .el-table .el-table__cell{
  box-sizing: border-box;
  min-width: 0;
  padding: 8px 0;
  position: relative;
  text-align: left;
  text-overflow: ellipsis;
  vertical-align: middle;
  z-index: unset !important;
}
.pagination{
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-button+.el-button {
  margin-left: 10px;
}

.user-section {
  margin-bottom: 30px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 6px;
}

.user-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #303133;
  border-bottom: 1px solid #dcdfe6;
  padding-bottom: 8px;
}

.no-data,
.no-overtime-data {
  text-align: center;
  color: #909399;
  padding: 20px;
  font-size: 14px;
}

.ellipsis-1-line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 100%;
}

/* 确保超时预警表格内容左对齐 */
::v-deep .user-section .el-table {
  width: 100% !important;
  table-layout: fixed !important;
}

::v-deep .user-section .el-table .el-table__cell {
  text-align: left;
  padding-left: 15px;
  padding-right: 10px;
  box-sizing: border-box;
}

::v-deep .user-section .el-table .el-table__header .el-table__cell .cell {
  text-align: center !important;
  font-weight: bold;
}

/* 确保表格单元格div内容也左对齐 */
::v-deep .user-section .el-table .el-table__cell .cell {
  text-align: left !important;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 大屏适配 */
@media (min-width: 1600px) {
  ::v-deep .user-section .el-table {
    font-size: 14px;
  }
  
  ::v-deep .user-section .el-table .el-table__row {
    height: 40px;
  }
  
  ::v-deep .user-section .el-table .el-table__cell {
    padding-left: 18px;
    padding-right: 12px;
  }
}
</style>